import React from 'react';
import ConfirmDialog from './ConfirmDialog';

interface AlertDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
  okText?: string;
  variant?: 'danger' | 'warning' | 'info' | 'success';
}

const AlertDialog: React.FC<AlertDialogProps> = ({
  isOpen,
  onClose,
  title,
  message,
  okText = 'OK',
  variant = 'info'
}) => {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      message={message}
      confirmText={okText}
      type="alert"
      variant={variant}
    />
  );
};

export default AlertDialog; 